import Axios from "axios";
import {
    SET_RFQ_LIST,
    UNSET_RFQ_LIST,
    SET_QUOTATIONABLLE_RFQ_LIST,
    UNSET_QUOTATIONABLLE_RFQ_LIST,
  } from "@/store/mutation-types";
import {
  saveUpdateRfq,
  getRfqList,
  getRfqById as getRfqByIdApi,
  getQuotationableRfqList
} from "@/store/api";
// initial state
const state = {
  getRfqList: [],
  editingRfq: null,
  getQuotationableRfqList:[],
};

const getters = {
  getRfqList(state) {
    return state.getRfqList;
  },
  getQuotationableRfqList(state) {
    return state.getQuotationableRfqList;
  },
  getEditingRfq: (state) => { 
    return state.editingRfq;
  },
};

const mutations = {
  [SET_RFQ_LIST](state, data) {
    state.getRfqList = data;
  },
  [UNSET_RFQ_LIST](state) {
    state.getRfqList = [];
  },
  [SET_QUOTATIONABLLE_RFQ_LIST](state, data) {
    state.getQuotationableRfqList = data;
  },
  [UNSET_QUOTATIONABLLE_RFQ_LIST](state) {
    state.getQuotationableRfqList = [];
  },
  setEditingRfq(state, rfq) {
    state.editingRfq = rfq;
  },
};

const actions = {
  saveUpdateRfq({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateRfq, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getRfqList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getRfqList, data)
        .then(function (response) {
          commit('SET_RFQ_LIST', response.data.data)
          console.log(response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_RFQ_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getQuotationableRfqList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getQuotationableRfqList, data)
        .then(function (response) {
          commit('SET_QUOTATIONABLLE_RFQ_LIST', response.data.data)
          console.log(response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_QUOTATIONABLLE_RFQ_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getRfqById({ commit }, id) {
    const getRfqById = `${getRfqByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getRfqById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
